/* Harmonizer demo: a <harmonizer-demo> custom element. Each instance keeps
   its own audio, analyser and state, so two on one page cannot collide.
   Audio only starts on the Hear it button. Nothing autoplays. */
(function () {
  if (window.customElements.get('harmonizer-demo')) return;

  // Chord changes read frame by frame from the demo video (30 fps). [time in s, A, B, C, D]
  var TIMELINE = [
    [0.0, -4, -9, -11, 0], [1.433, -5, -7, -11, 0], [2.067, -2, -3, -7, 0], [3.233, -5, -10, 0, 0],
    [4.233, -2, -3, -7, 0], [5.367, 0, 0, 0, 0], [7.0, -5, -7, -8, 0], [9.233, -2, -3, -7, 0],
    [10.333, -4, -9, -11, 0], [11.367, -5, -7, -11, 0], [12.333, -4, -9, 0, 0], [12.933, -2, -3, -7, 0],
    [14.367, -5, -7, -11, 0], [15.233, -4, -9, 0, 0], [15.933, -2, -3, -7, 0], [16.533, -4, -9, -11, 0],
    [17.133, -5, -7, -11, 0], [17.9, -4, -9, 0, 0], [18.233, -2, -3, -7, 0], [18.733, -4, -9, -11, 0],
    [19.867, -5, -7, -11, 0], [20.567, 0, 0, 0, 0]
  ];
  // Each distinct chord gets a Harmonizer key, in order of first appearance.
  var CHORDS = [];
  TIMELINE.forEach(function (r) {
    var k = r.slice(1).join(',');
    if (r.slice(1).some(function (v) { return v; }) && CHORDS.indexOf(k) < 0) CHORDS.push(k);
  });
  var NAMES = { 0: 'off', 1: 'min 2nd', 2: 'maj 2nd', 3: 'min 3rd', 4: 'maj 3rd', 5: '4th', 6: 'tritone', 7: '5th', 8: 'min 6th', 9: 'maj 6th', 10: 'min 7th', 11: 'maj 7th', 12: 'octave' };
  var CC = [11, 12, 13, 14];
  var nameOf = function (v) { return v === 0 ? 'off' : (NAMES[Math.abs(v) % 13] || '') + (v > 0 ? ' up' : ' down'); };
  var fmt = function (v) { return v > 0 ? '+' + v : String(v); };
  var mmss = function (s) { return Math.floor(s / 60) + ':' + String(Math.floor(s % 60)).padStart(2, '0'); };
  // LED colours exactly as the firmware: colorwheel(i * 21) for key i, active key white and pulsing.
  function cw(pos) { pos &= 255; if (pos < 85) return [255 - pos * 3, pos * 3, 0]; if (pos < 170) { pos -= 85; return [0, 255 - pos * 3, pos * 3]; } pos -= 170; return [pos * 3, 0, 255 - pos * 3]; }
  // Same hue order as the firmware's colorwheel(i * 21), with the darker hues lifted to the same perceptual lightness (OKLCH) so no key looks dim.
  function okHue(c) {
    var l = c.map(function (v) { v /= 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    var L = Math.cbrt(0.4122214708 * l[0] + 0.5363325363 * l[1] + 0.0514459929 * l[2]);
    var M = Math.cbrt(0.2119034982 * l[0] + 0.6806995451 * l[1] + 0.1073969566 * l[2]);
    var S = Math.cbrt(0.0883024619 * l[0] + 0.2817188376 * l[1] + 0.6299787005 * l[2]);
    var a = 1.9779984951 * L - 2.4285922050 * M + 0.4505937099 * S, b = 0.0259040371 * L + 0.7827717662 * M - 0.8086757660 * S;
    return [0.2104542553 * L + 0.7936177850 * M - 0.0040720468 * S, (Math.atan2(b, a) * 180 / Math.PI + 360) % 360];
  }
  var LED = Array.from({ length: 12 }, function (_, i) {
    var lh = okHue(cw(i * 21)), l = lh[0], h = lh[1];
    var floor = 0.7 + 0.16 * Math.exp(-Math.pow((h - 105) / 22, 2)); // yellow only reads as yellow when it's light
    return 'oklch(' + Math.max(l, floor).toFixed(3) + ' 0.24 ' + h.toFixed(1) + ')';
  });
  // Upright, the firmware's KEY_ORDER puts key 1 top-right and runs keys 1-4 down the right-hand column.
  var KEY_ORDER = [2, 5, 8, 11, 1, 4, 7, 10, 0, 3, 6, 9];
  var slots = new Array(12); KEY_ORDER.forEach(function (phys, i) { slots[phys] = i; });
  // Each key is a lit clear keycap: dim tinted centre out to the full colour at the edge, lighter inset rim, outer glow. Active key is the same in white.
  var keyStyle = function (c, on) {
    var col = on ? '#ffffff' : c;
    return 'background:radial-gradient(circle at 50% 50%, color-mix(in oklch, ' + col + ' 35%, #1a1a22) 0 14%, color-mix(in oklch, ' + col + ' 70%, #101018) 30%, ' + col + ' 75%);box-shadow:inset 0 0 0 2px color-mix(in oklch, ' + col + ' 45%, white),inset 0 0 10px color-mix(in oklch, ' + col + ' 70%, white),0 0 ' + (on ? 18 : 12) + 'px color-mix(in oklch, ' + col + ' ' + (on ? 70 : 50) + '%, transparent)';
  };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function knob(v) {
    var R = 26, cx = 32, cy = 32, a0 = -225, span = 270;
    var ang = a0 + span * ((v + 24) / 48), mid = -90;
    var pt = function (d, r) { r = r || R; return [cx + r * Math.cos(d * Math.PI / 180), cy + r * Math.sin(d * Math.PI / 180)]; };
    var b0 = pt(a0), b1 = pt(a0 + span), p0 = pt(mid), p1 = pt(ang), dp = pt(ang, 17);
    var arc = v ? '<path d="M' + p0[0] + ' ' + p0[1] + ' A' + R + ' ' + R + ' 0 0 ' + (ang > mid ? 1 : 0) + ' ' + p1[0] + ' ' + p1[1] + '" fill="none" stroke="var(--hzd-lime)" stroke-width="4" stroke-linecap="round"/>' : '';
    return '<svg width="64" height="64" viewBox="0 0 64 64" aria-hidden="true"><path d="M' + b0[0] + ' ' + b0[1] + ' A' + R + ' ' + R + ' 0 1 1 ' + b1[0] + ' ' + b1[1] + '" fill="none" stroke="var(--hzd-n5)" stroke-width="4" stroke-linecap="round"/>' + arc + '<circle cx="32" cy="32" r="18" fill="var(--hzd-n8)" stroke="var(--hzd-n5)"/><circle cx="' + dp[0] + '" cy="' + dp[1] + '" r="2.6" fill="' + (v ? 'var(--hzd-lime)' : '#fff') + '"/></svg>';
  }

  class HarmonizerDemo extends HTMLElement {}

  HarmonizerDemo.prototype.connectedCallback = function () {
    if (this.dataset.hzdReady) return;
    this.dataset.hzdReady = '1';
    var self = this;
    var q = function (sel) { return self.querySelector(sel); };
    this.$ = q;
    this.audio = q('audio');
    this.btn = q('.hzd__btn');
    this.current = null;
    this.lv = { In: 0, Out: 0, 0: 0, 1: 0, 2: 0, 3: 0 };
    this.pk = { In: 0, Out: 0, 0: 0, 1: 0, 2: 0, 3: 0 };

    q('.hzd__cards').innerHTML = 'ABCD'.split('').map(function (k, i) {
      return '<div class="hzd__card" data-card="' + i + '"><div class="hzd__card-top"><span class="hzd__badge">' + k + '</span><span class="hzd__lbl">Voice ' + k + '</span><span style="width:20px"></span></div><div class="hzd__knobrow"><div data-knob="' + i + '"></div><div class="hzd__track"><div class="hzd__fill" data-fill="' + i + '"></div><div class="hzd__pk" data-pk="' + i + '"></div></div></div><div class="hzd__num" data-num="' + i + '">0</div><div class="hzd__note" data-note="' + i + '">off</div></div>';
    }).join('');
    var keys = q('.hzd__mk');
    if (keys) {
      keys.innerHTML = slots.map(function (i) { return '<div class="hzd__k" data-key="' + i + '" style="' + keyStyle(LED[i], false) + '"></div>'; }).join('');
    }
    this.apply(TIMELINE[0], false);

    this.btn.addEventListener('click', function () { self.toggle(); });
    this.audio.addEventListener('ended', function () { self.btn.textContent = self.btn.dataset.again; self.current = null; });
    // The visual clock only starts once sound is really coming out: the audio
    // context is running and the element has fired 'playing'.
    this.audio.addEventListener('playing', function () {
      var go = function () { self.anchor = null; self.run(); };
      if (self.actx && self.actx.state !== 'running') self.actx.resume().then(go, go); else go();
    });
    // Stalls and pauses drop the interpolation anchor so the clock never runs ahead.
    ['waiting', 'pause', 'seeking'].forEach(function (e) { self.audio.addEventListener(e, function () { self.anchor = null; }); });
  };

  // Time from the audio element to the speaker: Bluetooth and phone speakers add 100-300 ms.
  // outputLatency where the browser has it; otherwise estimate it from getOutputTimestamp().
  HarmonizerDemo.prototype.latency = function () {
    var c = this.actx; if (!c) return 0;
    var out = c.outputLatency;
    if (typeof out !== 'number' && c.getOutputTimestamp) {
      var ts = c.getOutputTimestamp();
      if (ts && ts.contextTime > 0) out = c.currentTime - ts.contextTime - (performance.now() - ts.performanceTime) / 1000;
    }
    var l = (typeof out === 'number' && out > 0 ? out : 0) + (typeof c.baseLatency === 'number' ? c.baseLatency : 0);
    return Math.min(0.5, Math.max(0, l));
  };

  // Where the listener is in the track. iOS Safari updates currentTime coarsely, so between
  // updates the clock runs on from the last change with performance.now().
  HarmonizerDemo.prototype.clock = function () {
    var a = this.audio, ct = a.currentTime, now = performance.now();
    if (a.ended) { this.anchor = null; return ct; }
    if (a.paused || a.seeking || a.readyState < 3) { this.anchor = null; return Math.max(0, ct - this.latency()); }
    var an = this.anchor;
    if (!an || an.ct !== ct) { this.anchor = an = { ct: ct, at: now }; }
    var t = ct + Math.min(0.25, (now - an.at) / 1000) * (a.playbackRate || 1);
    return Math.max(0, t - this.latency());
  };

  HarmonizerDemo.prototype.run = function () {
    if (this.raf) return;
    var self = this;
    this.raf = requestAnimationFrame(function () { self.tick(); });
  };

  HarmonizerDemo.prototype.apply = function (row, flash) {
    var self = this, q = this.$;
    var vals = row.slice(1), key = vals.join(',');
    if (key === this.current) return;
    this.current = key;
    vals.forEach(function (v, i) {
      q('[data-knob="' + i + '"]').innerHTML = knob(v);
      q('[data-num="' + i + '"]').textContent = fmt(v);
      q('[data-note="' + i + '"]').textContent = nameOf(v);
      var c = q('[data-card="' + i + '"]');
      c.classList.toggle('hzd--on', v !== 0);
      if (flash && v !== 0 && !reduced) { c.classList.add('hzd--flash'); setTimeout(function () { c.classList.remove('hzd--flash'); }, 180); }
    });
    // No key is highlighted until the demo plays; before that all 12 show their colours.
    var ki = flash ? CHORDS.indexOf(key) : -1;
    LED.forEach(function (c, i) {
      var k = q('[data-key="' + i + '"]'); if (!k) return;
      var on = i === ki;
      k.classList.toggle('hzd--on', on);
      k.setAttribute('style', keyStyle(c, on));
    });
    var live = vals.filter(function (v) { return v; }).length;
    q('.hzd__chip--harm').classList.toggle('hzd--on', live > 0);
    q('.hzd__harm-text').textContent = live ? live + ' voices live' : 'Bypassed';
    q('.hzd__status-text').textContent = live ? 'Harmony active' : (flash ? 'All voices off: your dry sound only' : 'Press Hear it to play the demo');
    q('.hzd__status').classList.toggle('hzd--idle', !live);
    if (flash) {
      var changed = vals.findIndex(function (v) { return v !== 0; });
      q('.hzd__midi-text').textContent = 'CH 3 · CC ' + CC[Math.max(0, changed)] + ' · ' + (64 + (vals[Math.max(0, changed)] || 0));
      var m = q('.hzd__chip--midi'); m.classList.add('hzd--on');
      clearTimeout(this.midiT); this.midiT = setTimeout(function () { m.classList.remove('hzd--on'); }, 250);
    }
  };

  HarmonizerDemo.prototype.setBar = function (id, v) {
    var lv = this.lv, pk = this.pk;
    lv[id] = v > lv[id] ? v : lv[id] * 0.88;
    pk[id] = Math.max(lv[id], pk[id] - 0.008);
    this.$('[data-fill="' + id + '"]').style.height = (lv[id] * 100) + '%';
    this.$('[data-pk="' + id + '"]').style.bottom = (pk[id] * 100) + '%';
  };

  HarmonizerDemo.prototype.level = function () {
    if (!this.analyser) return 0;
    this.analyser.getFloatTimeDomainData(this.data);
    var s = 0, d = this.data;
    for (var i = 0; i < d.length; i++) s += d[i] * d[i];
    var db = 20 * Math.log10(Math.sqrt(s / d.length) + 1e-6);
    return Math.max(0, Math.min(1, (db + 48) / 42));
  };

  HarmonizerDemo.prototype.tick = function () {
    var self = this, q = this.$, audio = this.audio;
    this.raf = 0;
    var t = this.clock();
    var row = TIMELINE[0];
    for (var i = 0; i < TIMELINE.length; i++) if (TIMELINE[i][0] <= t) row = TIMELINE[i];
    this.apply(row, true);
    var L = audio.paused ? 0 : this.level();
    this.setBar('In', L); this.setBar('Out', Math.min(1, L * 1.05));
    row.slice(1).forEach(function (v, i) { self.setBar(i, v ? L * (reduced ? 0.9 : 0.82 + 0.1 * Math.sin(t * 7 + i)) : 0); });
    var hear = L > 0.05;
    q('.hzd__chip--audio').classList.toggle('hzd--on', hear);
    q('.hzd__audio-text').textContent = hear ? '44.1 kHz · 20 ms' : 'No audio coming in';
    var dur = audio.duration || 21.5;
    q('.hzd__prog b').style.width = (t / dur * 100) + '%';
    q('.hzd__time').textContent = mmss(t) + ' / ' + mmss(dur);
    var lv = this.lv, active = false;
    for (var k in lv) if (lv[k] > 0.01) active = true;
    if (!audio.paused || active) this.run();
  };

  HarmonizerDemo.prototype.toggle = function () {
    var audio = this.audio, btn = this.btn;
    if (!this.actx) {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (Ctx) {
        this.actx = new Ctx();
        var src = this.actx.createMediaElementSource(audio);
        this.analyser = this.actx.createAnalyser();
        this.analyser.fftSize = 1024;
        this.data = new Float32Array(this.analyser.fftSize);
        src.connect(this.analyser);
        this.analyser.connect(this.actx.destination);
      }
    }
    if (this.actx) this.actx.resume();
    if (audio.paused) {
      if (audio.ended) audio.currentTime = 0;
      // play() stays inside the tap so iOS allows it; the visuals wait for the 'playing' event.
      var p = audio.play();
      if (p && p.catch) p.catch(function () { btn.textContent = btn.dataset.play; });
      btn.textContent = btn.dataset.pause;
    } else {
      audio.pause();
      btn.textContent = btn.dataset.play;
    }
  };

  window.customElements.define('harmonizer-demo', HarmonizerDemo);
})();
